<template>
  <v-btn v-bind="mergedAttrs">
    <BrandIcon class="text-h5 mr-2" name="apple" />
    <slot />
  </v-btn>
</template>

<script setup>
import { computed, useAttrs, defineOptions } from 'vue'
import { mergeAttrs } from '@/utils/vue-attrs'
import BrandIcon from './BrandIcon.vue'

// Get attrs
const attrs = useAttrs()

// Define inheritAttrs: false to prevent attrs from being applied to root element
defineOptions({
  inheritAttrs: false,
  name: 'AuthBtnApple'
})

// Computed properties
const commonAttrs = computed(() => {
  return {
    color: '#050708',
    variant: 'flat',
    class: [
      'text-none text-white',
      'rounded-lg',
    ],
  }
})

// Merge attributes properly
const mergedAttrs = computed(() => {
  return mergeAttrs(commonAttrs.value, attrs)
})
</script>

<style lang="scss" scoped>
.v-btn {
  border: none;
}
</style>
